import Reset from './Reset';

export default Reset;
